// extracted by mini-css-extract-plugin
export var alertIcon = "_tc-0";